import { memo } from 'react';

import { Star } from 'icons';
import { twMerge } from 'tailwind-merge';

const MAX_RATING = 5;

function AgentNameRatingBase({ value }: { value?: number | null }) {
  const hasRating = typeof value === 'number' && value > 0;
  const normalizedValue = hasRating ? Math.min(MAX_RATING, Math.max(1, value)) : 0;
  const fillPercentage = (normalizedValue / MAX_RATING) * 100;

  const stars = Array.from({ length: MAX_RATING }, (_, index) => <Star key={index} />);

  return (
    <div
      className="inline-flex items-center justify-center gap-1.5 align-middle"
      aria-label={hasRating ? `Rating ${normalizedValue}` : 'Rating N/A'}
    >
      <div className="relative text-sm leading-none">
        <div className="flex text-v2blueGray-100 text-[26px]">{stars}</div>
        <div
          className={twMerge('absolute inset-y-0 left-0 overflow-hidden text-[#FBBA1D]')}
          style={{ width: `${fillPercentage}%` }}
        >
          <div className="flex w-max text-[26px]">{stars}</div>
        </div>
      </div>
      <div className="text-base font-semibold leading-4 text-v2blueGray-900 pt-1">
        {hasRating ? (
          Number.isInteger(normalizedValue) ? (
            normalizedValue
          ) : (
            normalizedValue.toFixed(1)
          )
        ) : (
          <span className="text-sm">N/A</span>
        )}
      </div>
    </div>
  );
}

export const AgentNameRating = memo(AgentNameRatingBase);
